export default __webpack_public_path__ + "locales/pt/PreparationPortal.json?hash=0e69ac83b1ac62bc8e4b83ceab1b6796";